{
  "familyId": "TOPO-NL-PROV",
  "questions": [
    {
      "id": "TOPO-NL-PROV-001",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Wat is de hoofdstad van de provincie Gelderland?",
      "options": [
        "Arnhem",
        "Nijmegen",
        "Apeldoorn",
        "Ede"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Provinciale hoofdsteden",
            "content": "Elke provincie heeft een hoofdstad waar het provinciebestuur zit. Arnhem is de hoofdstad van Gelderland.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_capital_match",
      "variantIndex": 1,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Arnhem is de hoofdstad van Gelderland. Daar zit het provinciebestuur. Nijmegen, Apeldoorn en Ede zijn ook steden in Gelderland, maar niet de hoofdstad.",
        "solutionSteps": [
          "Gelderland is een grote provincie in het oosten van Nederland",
          "De hoofdstad is Arnhem",
          "Ezelsbruggetje: Arnhem = Administratie"
        ],
        "distractorExplanations": {
          "0": "Goed! Arnhem is de hoofdstad van Gelderland.",
          "1": "Nijmegen is een grote stad in Gelderland, maar niet de hoofdstad. De hoofdstad is Arnhem.",
          "2": "Apeldoorn is bekend van Paleis Het Loo, maar de hoofdstad van Gelderland is Arnhem.",
          "3": "Ede ligt in Gelderland, maar is niet de hoofdstad. De hoofdstad is Arnhem."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-001-OPT1",
            "optionIndex": 1,
            "label": "De hoofdstad is Arnhem"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-001-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Apeldoorn"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-001-OPT3",
            "optionIndex": 3,
            "label": "De hoofdstad is Arnhem"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-002",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Welke provincie ligt in het noordoosten van Nederland en grenst aan zowel Duitsland als de Noordzee?",
      "options": [
        "Groningen",
        "Friesland",
        "Zuid-Holland",
        "Utrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Grenzen van provincies",
            "content": "In het noordoosten van Nederland ligt een provincie die zowel aan Duitsland (in het oosten) als aan de Noordzee (in het noorden) grenst. Dat is Groningen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_border_reasoning",
      "variantIndex": 2,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Groningen ligt in het noordoosten. Het grenst aan Duitsland (in het oosten) én aan de Noordzee (in het noorden). Friesland grenst wel aan de zee, maar niet aan Duitsland.",
        "solutionSteps": [
          "Duitsland ligt in het oosten van Nederland",
          "De Noordzee ligt in het noorden en westen",
          "Welke provincie raakt beide? Groningen (noordoost)",
          "Friesland raakt de zee maar niet Duitsland"
        ],
        "distractorExplanations": {
          "0": "Goed! Groningen grenst aan Duitsland (oost) en de Noordzee (noord).",
          "1": "Friesland grenst wel aan de zee, maar niet aan Duitsland. Groningen ligt oostelijker en raakt wél de Duitse grens.",
          "2": "Zuid-Holland ligt aan de Noordzee, maar helemaal niet bij Duitsland.",
          "3": "Utrecht ligt midden in Nederland en grenst aan geen van beide."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-002-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Friesland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-002-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Zuid-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-002-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Utrecht"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-003",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Wat is de hoofdstad van de provincie Noord-Holland?",
      "options": [
        "Haarlem",
        "Alkmaar",
        "Hilversum",
        "Den Helder"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Hoofdstad vs. grootste stad",
            "content": "Amsterdam is de hoofdstad van Nederland, maar Haarlem is de hoofdstad van de provincie Noord-Holland. Dit is een bekende strikvraag!",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_capital_trick",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Haarlem is de hoofdstad van Noord-Holland. Amsterdam is de hoofdstad van heel Nederland, maar niet van de provincie. Dit is de bekendste strikvraag bij topografie!",
        "solutionSteps": [
          "Amsterdam = hoofdstad van Nederland",
          "Haarlem = hoofdstad van de provincie Noord-Holland",
          "Dit is de bekendste strikvraag bij topografie!"
        ],
        "distractorExplanations": {
          "0": "Goed! Haarlem is de hoofdstad van Noord-Holland. Veel mensen denken Amsterdam, maar dat is de hoofdstad van heel Nederland.",
          "1": "Alkmaar is bekend van de kaasmarkt, maar is niet de hoofdstad van Noord-Holland. De hoofdstad is Haarlem.",
          "2": "Hilversum is bekend van de media (tv en radio), maar is niet de hoofdstad. De hoofdstad van Noord-Holland is Haarlem.",
          "3": "Den Helder ligt aan de punt van Noord-Holland, maar is niet de hoofdstad. De hoofdstad is Haarlem."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-003-OPT1",
            "optionIndex": 1,
            "label": "De hoofdstad is Haarlem"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-003-OPT2",
            "optionIndex": 2,
            "label": "De hoofdstad van Noord-Holland is Haarlem"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-003-OPT3",
            "optionIndex": 3,
            "label": "De hoofdstad is Haarlem"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-004",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Hoeveel provincies heeft Nederland?",
      "options": [
        "12",
        "10",
        "11",
        "14"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Provincies van Nederland",
            "content": "Nederland heeft 12 provincies. Tel ze per regio: Noord (3), Oost (3), West (3), Zuid (3) = 12.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_count",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Nederland heeft 12 provincies. Noord (3): Groningen, Friesland, Drenthe. Oost (3): Overijssel, Flevoland, Gelderland. West (3): Utrecht, Noord-Holland, Zuid-Holland. Zuid (3): Zeeland, Noord-Brabant, Limburg.",
        "solutionSteps": [
          "Noord (3): Groningen, Friesland, Drenthe",
          "Oost (3): Overijssel, Flevoland, Gelderland",
          "West (3): Utrecht, Noord-Holland, Zuid-Holland",
          "Zuid (3): Zeeland, Noord-Brabant, Limburg",
          "Totaal: 4 × 3 = 12"
        ],
        "distractorExplanations": {
          "0": "Goed! Nederland heeft 12 provincies.",
          "1": "Dan vergeet je 2 provincies — vaak Flevoland en nog een andere. Onthoud: 4 × 3 = 12.",
          "2": "Dan vergeet je 1 provincie — vaak Flevoland, de jongste. Onthoud: 4 × 3 = 12.",
          "3": "Dat zijn er te veel. Nederland heeft 12 provincies. Onthoud: 4 × 3 = 12."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-004-OPT1",
            "optionIndex": 1,
            "label": "Onthoud: 4 × 3 = 12"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-004-OPT2",
            "optionIndex": 2,
            "label": "Onthoud: 4 × 3 = 12"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-004-OPT3",
            "optionIndex": 3,
            "label": "Dat zijn er te veel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-005",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Welke provincie is de jongste van Nederland?",
      "options": [
        "Flevoland",
        "Drenthe",
        "Zeeland",
        "Utrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Flevoland: jongste provincie",
            "content": "Flevoland is de jongste provincie. Het land is aangelegd door inpoldering van de Zuiderzee. Flevoland werd in 1986 een provincie.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_flevoland",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Flevoland is de jongste provincie van Nederland. Het land is gemaakt door inpoldering van de Zuiderzee. Flevoland werd pas in 1986 een provincie.",
        "solutionSteps": [
          "Flevoland is aangelegd door inpoldering",
          "Het werd in 1986 officieel een provincie",
          "Alle andere provincies bestaan al eeuwen"
        ],
        "distractorExplanations": {
          "0": "Goed! Flevoland is de jongste provincie, opgericht in 1986.",
          "1": "Drenthe is juist een van de oudste bewoonde gebieden van Nederland, met hunebedden uit de prehistorie.",
          "2": "Zeeland bestaat al eeuwen. De jongste provincie is Flevoland.",
          "3": "Utrecht is een van de oudste provincies. De jongste is Flevoland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-005-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Drenthe"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-005-OPT2",
            "optionIndex": 2,
            "label": "Zeeland bestaat al eeuwen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-005-OPT3",
            "optionIndex": 3,
            "label": "Utrecht is een van de oudste provincies"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-006",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Welke provincie is de grootste van Nederland?",
      "options": [
        "Gelderland",
        "Noord-Brabant",
        "Noord-Holland",
        "Friesland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Grootste provincie",
            "content": "Gelderland is de grootste provincie van Nederland qua oppervlakte. Het ligt in het midden-oosten van Nederland.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_largest",
      "variantIndex": 6,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Gelderland is de grootste provincie van Nederland. Het ligt in het midden-oosten en heeft steden als Arnhem, Nijmegen en Apeldoorn.",
        "solutionSteps": [
          "Gelderland is de grootste provincie qua oppervlakte",
          "Het ligt in het midden-oosten van Nederland"
        ],
        "distractorExplanations": {
          "0": "Goed! Gelderland is de grootste provincie van Nederland.",
          "1": "Noord-Brabant is de provincie met de meeste inwoners, maar Gelderland is groter qua oppervlakte.",
          "2": "Noord-Holland is kleiner dan Gelderland.",
          "3": "Friesland is groot, maar Gelderland is groter."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-006-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-006-OPT2",
            "optionIndex": 2,
            "label": "Noord-Holland is kleiner dan Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-006-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Friesland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-007",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "In welke provincie ligt de stad Maastricht?",
      "options": [
        "Limburg",
        "Noord-Brabant",
        "Gelderland",
        "Zeeland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Maastricht in Limburg",
            "content": "Maastricht is de hoofdstad van Limburg. Limburg is de lange, smalle provincie in het zuidoosten van Nederland.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_limburg",
      "variantIndex": 7,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Maastricht ligt in Limburg, de meest zuidelijke provincie van Nederland. Maastricht is ook de hoofdstad van Limburg.",
        "solutionSteps": [
          "Maastricht ligt in het zuiden van Nederland",
          "Het is de hoofdstad van Limburg"
        ],
        "distractorExplanations": {
          "0": "Goed! Maastricht is de hoofdstad van Limburg.",
          "1": "Noord-Brabant grenst aan Limburg, maar Maastricht ligt in Limburg.",
          "2": "Gelderland ligt ten noorden van Limburg.",
          "3": "Zeeland ligt in het zuidwesten, niet in het zuidoosten."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-007-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-007-OPT2",
            "optionIndex": 2,
            "label": "Gelderland ligt ten noorden van Limburg"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-007-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Zeeland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-008",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Welke provincie ligt precies in het midden van Nederland?",
      "options": [
        "Utrecht",
        "Gelderland",
        "Noord-Holland",
        "Overijssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Utrecht: midden van Nederland",
            "content": "Utrecht is de kleinste provincie en ligt precies in het midden van Nederland. Daarom is Utrecht een belangrijk knooppunt voor treinen en wegen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_utrecht_center",
      "variantIndex": 8,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Utrecht ligt in het midden van Nederland. Het is de kleinste provincie, maar heel belangrijk als knooppunt voor treinen en wegen.",
        "solutionSteps": [
          "Utrecht ligt precies in het midden van Nederland",
          "Het is de kleinste provincie",
          "Utrecht is een belangrijk knooppunt"
        ],
        "distractorExplanations": {
          "0": "Goed! Utrecht ligt in het midden van Nederland.",
          "1": "Gelderland ligt in het midden-oosten, maar Utrecht ligt nog centraler.",
          "2": "Noord-Holland ligt in het westen, niet in het midden.",
          "3": "Overijssel ligt in het oosten van Nederland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-008-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Gelderland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-008-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Noord-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-008-OPT3",
            "optionIndex": 3,
            "label": "Overijssel ligt in het oosten van Nederland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-009",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Welke drie provincies liggen in het noorden van Nederland?",
      "options": [
        "Groningen, Friesland en Drenthe",
        "Friesland, Overijssel en Flevoland",
        "Groningen, Drenthe en Overijssel",
        "Friesland, Groningen en Flevoland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Noordelijke provincies",
            "content": "De drie noordelijke provincies zijn Groningen, Friesland en Drenthe. Ze worden samen ook wel 'Noord-Nederland' genoemd.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_north",
      "variantIndex": 9,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De drie noordelijke provincies zijn Groningen, Friesland en Drenthe. Overijssel en Flevoland liggen in het oosten, niet in het noorden.",
        "solutionSteps": [
          "Noord-Nederland = Groningen, Friesland, Drenthe",
          "Overijssel en Flevoland horen bij het oosten"
        ],
        "distractorExplanations": {
          "0": "Goed! Groningen, Friesland en Drenthe zijn de drie noordelijke provincies.",
          "1": "Overijssel hoort niet bij het noorden maar bij het oosten.",
          "2": "Overijssel hoort bij het oosten, niet bij het noorden.",
          "3": "Flevoland hoort bij het oosten, niet bij het noorden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-009-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Friesland, Overijssel en Flevol"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-009-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Groningen, Drenthe en Overijsse"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-009-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Friesland, Groningen en Flevola"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-010",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Welke provincie ligt in het zuidwesten van Nederland en bestaat uit eilanden?",
      "options": [
        "Zeeland",
        "Zuid-Holland",
        "Noord-Brabant",
        "Limburg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Zeeland",
            "content": "Zeeland ligt in het zuidwesten en bestaat uit eilanden en schiereilanden. De naam 'Zeeland' betekent 'zeeland' — land in de zee.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_zeeland",
      "variantIndex": 10,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Zeeland ligt in het zuidwesten van Nederland. Het bestaat uit eilanden en schiereilanden. De naam betekent 'land in de zee'.",
        "solutionSteps": [
          "Zeeland ligt in het zuidwesten",
          "Het bestaat uit eilanden en schiereilanden",
          "De naam betekent 'land in de zee'"
        ],
        "distractorExplanations": {
          "0": "Goed! Zeeland ligt in het zuidwesten en bestaat uit eilanden.",
          "1": "Zuid-Holland ligt ten noorden van Zeeland.",
          "2": "Noord-Brabant ligt ten oosten van Zeeland en bestaat niet uit eilanden.",
          "3": "Limburg ligt in het zuidoosten, niet in het zuidwesten."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-010-OPT1",
            "optionIndex": 1,
            "label": "Zuid-Holland ligt ten noorden van Zeeland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-010-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-010-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Limburg"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-011",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Wat is de hoofdstad van de provincie Zuid-Holland?",
      "options": [
        "Den Haag",
        "Leiden",
        "Delft",
        "Dordrecht"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Den Haag: hoofdstad Zuid-Holland",
            "content": "Den Haag is de hoofdstad van Zuid-Holland. Rotterdam is de grootste stad, maar niet de hoofdstad. Den Haag is ook de regeringszetel van Nederland.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_zh_capital",
      "variantIndex": 11,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Den Haag is de hoofdstad van Zuid-Holland. Rotterdam is de grootste stad, maar niet de hoofdstad. Den Haag is ook de plaats waar de regering zit.",
        "solutionSteps": [
          "Den Haag = hoofdstad van Zuid-Holland",
          "Rotterdam = grootste stad, maar niet de hoofdstad",
          "Den Haag = ook de regeringszetel van Nederland"
        ],
        "distractorExplanations": {
          "0": "Goed! Den Haag is de hoofdstad van Zuid-Holland. Veel mensen denken Rotterdam, maar dat is de grootste stad — niet de hoofdstad.",
          "1": "Leiden is een bekende universiteitsstad in Zuid-Holland, maar niet de hoofdstad. De hoofdstad is Den Haag.",
          "2": "Delft is bekend van Delfts Blauw en de TU Delft, maar is niet de hoofdstad. De hoofdstad van Zuid-Holland is Den Haag.",
          "3": "Dordrecht is een van de oudste steden van Nederland, maar niet de hoofdstad van Zuid-Holland. De hoofdstad is Den Haag."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-011-OPT1",
            "optionIndex": 1,
            "label": "De hoofdstad is Den Haag"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-011-OPT2",
            "optionIndex": 2,
            "label": "De hoofdstad van Zuid-Holland is Den Haag"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-011-OPT3",
            "optionIndex": 3,
            "label": "De hoofdstad is Den Haag"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-PROV-012",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "matching",
      "question": "Koppel elke provincie aan de juiste hoofdstad.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Gelderland",
            "right": "Arnhem"
          },
          {
            "left": "Noord-Holland",
            "right": "Haarlem"
          },
          {
            "left": "Limburg",
            "right": "Maastricht"
          },
          {
            "left": "Overijssel",
            "right": "Zwolle"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Provinciale hoofdsteden",
            "content": "Arnhem = Gelderland, Haarlem = Noord-Holland, Maastricht = Limburg, Zwolle = Overijssel.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "province_capital_matching",
      "variantIndex": 12,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Gelderland → Arnhem, Noord-Holland → Haarlem (niet Amsterdam!), Limburg → Maastricht, Overijssel → Zwolle.",
        "solutionSteps": [
          "Gelderland → Arnhem",
          "Noord-Holland → Haarlem (niet Amsterdam!)",
          "Limburg → Maastricht",
          "Overijssel → Zwolle"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-PROV-013",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "matching",
      "question": "Koppel elke provincie aan de juiste hoofdstad.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Friesland",
            "right": "Leeuwarden"
          },
          {
            "left": "Zuid-Holland",
            "right": "Den Haag"
          },
          {
            "left": "Drenthe",
            "right": "Assen"
          },
          {
            "left": "Zeeland",
            "right": "Middelburg"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Provinciale hoofdsteden",
            "content": "Friesland → Leeuwarden, Zuid-Holland → Den Haag (niet Rotterdam!), Drenthe → Assen, Zeeland → Middelburg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "province_capital_matching_2",
      "variantIndex": 13,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Friesland → Leeuwarden, Zuid-Holland → Den Haag (niet Rotterdam!), Drenthe → Assen, Zeeland → Middelburg.",
        "solutionSteps": [
          "Friesland → Leeuwarden",
          "Zuid-Holland → Den Haag (niet Rotterdam!)",
          "Drenthe → Assen",
          "Zeeland → Middelburg"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-PROV-014",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "matching",
      "question": "Koppel elke provincie aan de regio waar het ligt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Groningen",
            "right": "Noord"
          },
          {
            "left": "Gelderland",
            "right": "Oost"
          },
          {
            "left": "Utrecht",
            "right": "West"
          },
          {
            "left": "Noord-Brabant",
            "right": "Zuid"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Provincies per regio",
            "content": "Noord: Groningen, Friesland, Drenthe. Oost: Overijssel, Flevoland, Gelderland. West: Utrecht, Noord-Holland, Zuid-Holland. Zuid: Zeeland, Noord-Brabant, Limburg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "province_region_matching",
      "variantIndex": 14,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Groningen ligt in het noorden, Gelderland in het oosten, Utrecht in het westen, en Noord-Brabant in het zuiden.",
        "solutionSteps": [
          "Groningen → Noord",
          "Gelderland → Oost",
          "Utrecht → West",
          "Noord-Brabant → Zuid"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-PROV-015",
      "familyId": "TOPO-NL-PROV",
      "module": "Topo",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_provincies",
      "questionType": "multiple_choice",
      "question": "Welke provincie heeft de meeste inwoners?",
      "options": [
        "Zuid-Holland",
        "Noord-Holland",
        "Noord-Brabant",
        "Gelderland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_provincies"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Grootste provincie qua inwoners",
            "content": "Zuid-Holland heeft de meeste inwoners. Daar liggen grote steden als Rotterdam, Den Haag en Leiden dicht bij elkaar.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "province_most_people",
      "variantIndex": 15,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Zuid-Holland heeft de meeste inwoners van alle provincies. Daar liggen grote steden als Rotterdam, Den Haag en Leiden dicht bij elkaar.",
        "solutionSteps": [
          "Zuid-Holland heeft de meeste inwoners",
          "Grote steden: Rotterdam, Den Haag, Leiden, Delft, Dordrecht"
        ],
        "distractorExplanations": {
          "0": "Goed! Zuid-Holland heeft de meeste inwoners.",
          "1": "Noord-Holland heeft ook veel inwoners (Amsterdam!), maar Zuid-Holland heeft er meer.",
          "2": "Noord-Brabant heeft veel inwoners, maar Zuid-Holland heeft er meer.",
          "3": "Gelderland is de grootste qua oppervlakte, maar Zuid-Holland heeft meer inwoners."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-015-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Noord-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-015-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Noord-Brabant"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-PROV-015-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Gelderland"
          }
        ]
      }
    }
  ]
}